window.DocumentEditorHelper = {
    setupCustomContextMenuFilter: function (dotNetRef) {
        // Clean up previous instance if re-entering edit mode
        this.disposeCustomContextMenuFilter();

        window._editorHasSelection = false;
        const customTexts = ['Shorten Selection', 'Lengthen Selection', 'Rewrite with AI'];

        const applyFilter = function () {
            document.querySelectorAll('li').forEach(function (li) {
                const text = li.textContent.trim();
                if (customTexts.indexOf(text) !== -1) {
                    li.style.display = window._editorHasSelection ? '' : 'none';
                }
            });
        };

        const checkSelection = function () {
            if (!dotNetRef) return;
            dotNetRef.invokeMethodAsync('CheckSelectionFromJs').then(function (hasSelection) {
                window._editorHasSelection = hasSelection;
            }).catch(function () {
            });
        };

        const contextMenuHandler = function () {
            checkSelection();
            setTimeout(applyFilter, 100);
        };

        // Keep the selection state fresh on every user interaction
        const container = document.querySelector('.e-documenteditorcontainer');
        if (container) {
            container.addEventListener('mouseup', checkSelection);
            container.addEventListener('keyup', checkSelection);
            container.addEventListener('mousedown', checkSelection);
        }

        // When the context menu appears in DOM, apply a filter
        const observer = new MutationObserver(function (mutations) {
            for (let i = 0; i < mutations.length; i++) {
                for (let j = 0; j < mutations[i].addedNodes.length; j++) {
                    const node = mutations[i].addedNodes[j];
                    if (node.nodeType === 1 && node.querySelector && node.querySelector('li')) {
                        applyFilter();
                    }
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });

        // Backup: also re-check and re-apply on right-click after a delay
        document.addEventListener('contextmenu', contextMenuHandler);

        // Store references for cleanup
        this._ctxMenuState = {
            observer: observer,
            container: container,
            checkSelection: checkSelection,
            contextMenuHandler: contextMenuHandler
        };

        return true;
    },

    disposeCustomContextMenuFilter: function () {
        const state = this._ctxMenuState;
        if (!state) return;

        if (state.observer) state.observer.disconnect();
        if (state.container) {
            state.container.removeEventListener('mouseup', state.checkSelection);
            state.container.removeEventListener('keyup', state.checkSelection);
            state.container.removeEventListener('mousedown', state.checkSelection);
        }
        document.removeEventListener('contextmenu', state.contextMenuHandler);

        this._ctxMenuState = null;
        window._editorHasSelection = false;
    },

    saveAsBase64: async function (editorId) {
        try {
            console.log('[DocumentEditorHelper] Attempting to save document from editor:', editorId);

            const editorElement = document.getElementById(editorId);
            if (!editorElement) {
                console.error('[DocumentEditorHelper] Editor element not found:', editorId);
                throw new Error('Editor element not found');
            }

            console.log('[DocumentEditorHelper] Editor element found:', editorElement);

            const editorInstance = editorElement.ej2_instances?.[0];
            if (!editorInstance) {
                console.error('[DocumentEditorHelper] Syncfusion instance not found on element');
                console.log('[DocumentEditorHelper] Available properties:', Object.keys(editorElement));
                throw new Error('Syncfusion instance not found');
            }

            console.log('[DocumentEditorHelper] Syncfusion instance found:', editorInstance);
            console.log('[DocumentEditorHelper] Instance type:', editorInstance.constructor.name);

            let docEditor = editorInstance.documentEditor || editorInstance;

            if (!docEditor) {
                console.error('[DocumentEditorHelper] Document editor not found');
                throw new Error('Document editor not found');
            }

            console.log('[DocumentEditorHelper] Document editor found, calling saveAsBlob...');

            // Call saveAsBlob
            const blob = await docEditor.saveAsBlob('Docx');

            console.log('[DocumentEditorHelper] Blob created, size:', blob.size);

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const base64 = reader.result.split(',')[1];
                    console.log('[DocumentEditorHelper] Document converted to base64. Length:', base64.length);
                    resolve(base64);
                };
                reader.onerror = (error) => {
                    console.error('[DocumentEditorHelper] FileReader error:', error);
                    reject(error);
                };
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('[DocumentEditorHelper] Error saving document:', error);
            console.error('[DocumentEditorHelper] Stack:', error.stack);
            throw error;
        }
    }
};
